import { render, staticRenderFns } from "./SettingsEditOrganisation.vue?vue&type=template&id=7d839e9a&scoped=true"
import script from "./SettingsEditOrganisation.vue?vue&type=script&lang=js"
export * from "./SettingsEditOrganisation.vue?vue&type=script&lang=js"
import style0 from "./SettingsEditOrganisation.vue?vue&type=style&index=0&id=7d839e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d839e9a",
  null
  
)

export default component.exports